import React from "react";
import { Row, Col } from "react-bootstrap";
import Moment from 'react-moment';
import { useIntl } from 'react-intl';
import { MEASUREMENT_SYSTEM_TYPE, PACKAGE_MEASUREMENT_TYPE, AIR_EXPRESS_SERVICE_TYPE, CUSTOMS_CLEARANCE_TYPE } from "../../../services/flitEnum";
import HtmlReactParser from 'html-react-parser';
import cf from '../../../services/codeformatter';

export default function AirExpressDetailDetail({ airExpress, quoteRequest }) {
  const intl = useIntl();
  const wordWrap = { wordWrap: "break-word" };

  function formatNote(str) {
    var newStr = "" + str?.replace(/(?:\r\n|\r|\n)/g, '<br />');
    return newStr;
  }

  return (<>
    <Row className="mt-3">
      <Col>
        <h6 style={{ marginBottom: "10px" }}><b>{intl.formatMessage({ id: "SCHEDULE_INFORMATION" })}</b></h6>
      </Col>
    </Row>
    {airExpress.serviceType && airExpress.serviceType != AIR_EXPRESS_SERVICE_TYPE.UNKNOWN && <Row>
      <Col md="6">{intl.formatMessage({ id: "SERVICE_TYPE" })}</Col>
      <Col md="6">{cf.format('AirExpressServiceType', airExpress.serviceType, intl.locale)}</Col>
    </Row>}
    {airExpress.airWaybillNo && <Row>
      <Col md="6">{intl.formatMessage({ id: "AIR_WAYBILL_NO" })}</Col>
      <Col md="6" style={wordWrap}>{airExpress.airWaybillNo}</Col>
    </Row>}
    {airExpress.carrier && <Row>
      <Col md="6">{intl.formatMessage({ id: "CARRIER" })}</Col>
      <Col md="6" style={wordWrap}>{airExpress.carrier}</Col>
    </Row>}
    {airExpress.pickupOn && <Row>
      <Col md="6">{intl.formatMessage({ id: "PICKUP_ON" })}</Col>
      <Col md="6"><Moment format="LL">{airExpress.pickupOn}</Moment></Col>
    </Row>}
    {airExpress.documentCutOffOn && <Row>
      <Col md="6">{intl.formatMessage({ id: "DOCUMENT_CUT_OFF_ON" })}</Col>
      <Col md="6"><Moment format="LL">{airExpress.documentCutOffOn}</Moment></Col>
    </Row>}
    {airExpress.cargoCutOffOn && <Row>
      <Col md="6">{intl.formatMessage({ id: "CARGO_CUT_OFF_ON" })}</Col>
      <Col md="6"><Moment format="LL">{airExpress.cargoCutOffOn}</Moment></Col>
    </Row>}
    {airExpress.estimatedDepartureOn && <Row>
      <Col md="6">{intl.formatMessage({ id: "ESTIMATED_DEPARTURE_ON" })}</Col>
      <Col md="6"><Moment format="LL">{airExpress.estimatedDepartureOn}</Moment></Col>
    </Row>}
    {airExpress.estimatedArrivalOn && <Row>
      <Col md="6">{intl.formatMessage({ id: "ESTIMATED_ARRIVAL_ON" })}</Col>
      <Col md="6"><Moment format="LL">{airExpress.estimatedArrivalOn}</Moment></Col>
    </Row>}
    {airExpress.departedOn && <Row>
      <Col md="6">{intl.formatMessage({ id: "DEPARTED_ON" })}</Col>
      <Col md="6"><Moment format="LL">{airExpress.departedOn}</Moment></Col>
    </Row>}
    {airExpress.deliveredOn && <Row>
      <Col md="6">{intl.formatMessage({ id: "DELIVERED_ON" })}</Col>
      <Col md="6"><Moment format="LL">{airExpress.deliveredOn}</Moment></Col>
    </Row>}
    {airExpress.deliveryMethod && <Row>
      <Col md="6">{intl.formatMessage({ id: "DELIVERY_METHOD" })}</Col>
      <Col md="6" style={wordWrap}>{airExpress.deliveryMethod}</Col>
    </Row>}

    <Row className="mt-3">
      <Col>
        <h6 style={{ marginBottom: "10px" }}><b>{intl.formatMessage({ id: "CARGO_INFORMATION" })}</b></h6>
      </Col>
    </Row>
    {(airExpress.description || quoteRequest?.description) && <Row>
      <Col md="6">
        {intl.formatMessage({ id: "ITEM_DESCRIPTION" })}
      </Col>
      <Col md="6" style={wordWrap}>{airExpress.description || quoteRequest?.description}</Col>
    </Row>}
    {quoteRequest && <Row>
      <Col md="6">
        {intl.formatMessage({ id: "SUBMITTED_BY" })}
      </Col>
      <Col md="6" style={wordWrap}>{quoteRequest.submittedBy ? ((quoteRequest.submittedBy.firstName ?? "") + " " + (quoteRequest.submittedBy.lastName ?? "")) : ""}</Col>
    </Row>}
    <Row>
      <Col md="6">
        {intl.formatMessage({ id: "INCOTERMS" })}
      </Col>
      <Col md="6">{cf.format('Incoterms', airExpress.incoterms ?? quoteRequest?.incoterms, intl.locale)}</Col>
    </Row>
    {quoteRequest && <><Row>
      <Col md="6">{intl.formatMessage({ id: "PLANNED_TOTAL_WEIGHT" })}</Col>
      <Col md="6">{quoteRequest.measurementSystem == MEASUREMENT_SYSTEM_TYPE.METRIC ? quoteRequest.totalWeight + " kg" : quoteRequest.totalWeight + " lb"}</Col>
    </Row>
    <Row>
      <Col md="6">{intl.formatMessage({ id: "PLANNED_TOTAL_VOLUME" })}</Col>
      <Col md="6">{quoteRequest.measurementSystem == MEASUREMENT_SYSTEM_TYPE.METRIC ? quoteRequest.totalVolume + " cbm" : quoteRequest.totalVolume + " cbf"}</Col>
    </Row></>}
    {airExpress.totalWeight != 0 && <Row>
      <Col md="6">{intl.formatMessage({ id: "QUOTED_TOTAL_WEIGHT" })}</Col>
      <Col md="6">{airExpress.measurementSystem == MEASUREMENT_SYSTEM_TYPE.METRIC ? airExpress.totalWeight + " kg" : airExpress.totalWeight + " lb"}</Col>
    </Row>}
    {airExpress.totalVolume != 0 && <Row>
      <Col md="6">{intl.formatMessage({ id: "QUOTED_TOTAL_VOLUME" })}</Col>
      <Col md="6">{airExpress.measurementSystem == MEASUREMENT_SYSTEM_TYPE.METRIC ? airExpress.totalVolume + " cbm" : airExpress.totalVolume + " cbf"}</Col>
    </Row>}
    {airExpress.chargeableWeight && <Row>
      <Col md="6">{intl.formatMessage({ id: "CHARGEABLE_WEIGHT" })}</Col>
      <Col md="6">{airExpress.measurementSystem == MEASUREMENT_SYSTEM_TYPE.METRIC ? airExpress.chargeableWeight + " kg" : airExpress.chargeableWeight + " lb"}</Col>
    </Row>}
    {airExpress.totalPackages != null && airExpress.totalPackages != 0 && <Row>
      <Col md="6">{intl.formatMessage({ id: "TOTAL_PACKAGES" })}</Col>
      <Col md="6">{airExpress.totalPackages + " " + cf.format('PackageType', airExpress.totalPackageType, intl.locale)}</Col>
    </Row>}
    {airExpress.totalPieces != null && airExpress.totalPieces != 0 && <Row>
      <Col md="6">{intl.formatMessage({ id: "TOTAL_PIECES" })}</Col>
      <Col md="6">{airExpress.totalPieces}</Col>
    </Row>}
    {quoteRequest && <Row>
      <Col md="6">{intl.formatMessage({ id: "IS_PICKUP_DESC" })}</Col>
      <Col md="6">{quoteRequest.isPickup ? "YES" : "NO"}</Col>
    </Row>}

    {quoteRequest && <Row>
      <Col>
        {quoteRequest.packages && quoteRequest.packages.map((pk, index) =>
          <Row key={index}>
            <Col md="6">
              {intl.formatMessage({ id: "REQUEST_DETAILS" }) + " " + (index + 1)}
            </Col>
            <Col>
              <Row>
                <Col>
                  {pk.packageMeasurementType == PACKAGE_MEASUREMENT_TYPE.DIMENSION ? (quoteRequest.measurementSystem == MEASUREMENT_SYSTEM_TYPE.METRIC ?
                    pk.length + " cm x " + pk.width + " cm x " + pk.height + " cm" :
                    pk.length + " in x " + pk.width + " in x " + pk.height + " in") : (quoteRequest.measurementSystem == MEASUREMENT_SYSTEM_TYPE.METRIC ?
                      pk.volume + " cbm" :
                      pk.volume + " cbf")}
                  {pk.packageMeasurementType == PACKAGE_MEASUREMENT_TYPE.DIMENSION ? <br /> : " "}
                  {quoteRequest.measurementSystem == MEASUREMENT_SYSTEM_TYPE.METRIC ?
                    pk.weight + " kg" : pk.weight + " lb"} x {pk.numberOfPackages} {pk.packageType}
                </Col>
              </Row>
            </Col>
          </Row>
        )}
      </Col>
    </Row>}

    <Row className="mt-3">
      <Col>
        <h6 style={{ marginBottom: "10px" }}><b>{intl.formatMessage({ id: "CUSTOMS_CLEARANCE_TYPE" })}</b></h6>
      </Col>
    </Row>
    {airExpress.customsClearanceType && airExpress.customsClearanceType != CUSTOMS_CLEARANCE_TYPE.UNKNOWN && <Row>
      <Col md="6">{intl.formatMessage({ id: "CUSTOMS_CLEARANCE_TYPE" })}</Col>
      <Col md="6">{cf.format('CustomsClearanceType', airExpress.customsClearanceType, intl.locale)}</Col>
    </Row>}
    {airExpress.entryNumber && <Row>
      <Col md="6">{intl.formatMessage({ id: "ENTRY_NUMBER" })}</Col>
      <Col md="6" style={wordWrap}>{airExpress.entryNumber}</Col>
    </Row>}
    {airExpress.isIorBondReady != null && <Row>
      <Col md="6">{intl.formatMessage({ id: "IS_IOR_BOND_READY" })}</Col>
      <Col md="6">{airExpress.isIorBondReady ? "Yes" : "No"}</Col>
    </Row>}
    {airExpress.isFDA != null && <Row>
      <Col md="6">{intl.formatMessage({ id: "IS_FDA" })}</Col>
      <Col md="6">{airExpress.isFDA ? "Yes" : "No"}</Col>
    </Row>}
    {(airExpress.isDangerous != null || quoteRequest) && <Row>
      <Col md="6">{intl.formatMessage({ id: "DANGEROUS_ITEM" })}</Col>
      <Col md="6">{(airExpress.isDangerous ?? quoteRequest?.isDangerous) ? "Yes" : "No"}</Col>
    </Row>}

    {(airExpress.note || quoteRequest?.notes) && <><Row className="mt-3">
      <Col>
        <h6 style={{ marginBottom: "10px" }}><b>{intl.formatMessage({ id: "NOTES" })}</b></h6>
      </Col>
    </Row>
    <Row>
      <Col>
        {HtmlReactParser(formatNote((airExpress.note ?? "") + (airExpress.note && quoteRequest?.notes ? "\n" : "") + (quoteRequest?.notes ?? "")))}
      </Col>
    </Row></>}
  </>);
}
